module.exports = __webpack_public_path__ + "img/5.0c7b6d6d.jpg";